<template>
  <v-card>
    <v-card-text class="pa-0">
      <v-container class="pa-0">
        <div class="layout row ma-0">
          <div class="sm4 xs4 flex">
            <div
              class="mini-statistic layout column ma-0 justify-center align-center"
            >
              <v-icon size="56px" :color="color">{{ icon }}</v-icon>
            </div>
          </div>
          <div class="sm8 xs8 flex text-center py-3 white--text" :class="color">
            <div class="display-1">{{ title }}</div>
            <p class="font-weight-light">{{ subTitle }}</p>
          </div>
        </div>
      </v-container>
    </v-card-text>
    <v-divider v-if="$slots.actions" class="mx-3" />
    <v-card-actions v-if="$slots.actions">
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    icon: String,
    title: String,
    subTitle: String,
    color: String,
  },
};
</script>

<style>
.mini-statistic {
  height: 100%;
}
</style>
